import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import { Grid, Stack, Box, Paper, Typography, Divider } from '@mui/material';
import { useContext } from 'react';

import { ReportContext } from '@/Contexts/ReportContext';
import DateTimeFormatter from '@/shared-components/DateTimeFormatter';

const Banner = () => {
  const { selectedReport, selectedProject } = useContext(ReportContext);

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 4,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
        color: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 4px 20px 0 rgba(0,0,0,0.08)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-50%',
          right: '-10%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.05)',
          pointerEvents: 'none',
        },
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                p: 1.5,
                bgcolor: 'rgba(255, 255, 255, 0.15)',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <BusinessIcon sx={{ fontSize: 32, color: '#ffffff' }} />
            </Box>
            <Box>
              <Typography
                variant="caption"
                sx={{
                  textTransform: 'uppercase',
                  fontWeight: 700,
                  letterSpacing: 1.1,
                  color: 'rgba(255, 255, 255, 0.7)',
                  display: 'block',
                }}
              >
                Project Report
              </Typography>
              <Typography variant="h4" component="h1" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
                {selectedProject?.title}
              </Typography>
            </Box>
          </Stack>
        </Grid>

        <Grid sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 2,
              py: 1,
              bgcolor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
            }}
          >
            <WbSunnyIcon sx={{ color: '#fbbf24' }} />
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
                12°C
              </Typography>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.7rem' }}>
                Clear Sky
              </Typography>
            </Box>
          </Box>

          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} />

          <Stack direction="row" spacing={1.5} alignItems="center">
            <CalendarMonthIcon sx={{ color: 'rgba(255, 255, 255, 0.8)' }} />
            <Box>
              <Typography
                variant="caption"
                sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block', fontWeight: 500 }}
              >
                Report Date
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                <DateTimeFormatter rawDate={selectedReport?.reportDate} />
              </Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Banner;
